{
  "instances": {
    "flyway": {
      "label": "Flyway",
      "type": "Tipo",
      "checksum": "Checksum",
      "version": "Versão",
      "description": "Descrição",
      "script": "Script",
      "state": "Estado",
      "installed_by": "Instalado por",
      "installed_on": "Instalado em",
      "installed_rank": "Classificação instalada",
      "execution_time": "Tempo de Execução"
    }
  }
}
